export enum PopupType {
  AgeVerifier = 'age',
  PromoLightbox = 'promo_lightbox'
}

export interface AgeVerifierData {
  type: PopupType.AgeVerifier
  verified: boolean
}

export interface PromoLightboxData {
  type: PopupType.PromoLightbox
  lastShow: Date
}

export type PopupData = AgeVerifierData | PromoLightboxData
